function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button:not(.localization-selector)').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header && document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

// New -02-Dec : Start
document.addEventListener("DOMContentLoaded", () => {
        console.log('On load');
        const fieldset = document.querySelector('[data-option-index="option1"]');
        const selectedHTMLElement = fieldset.querySelector('input[type="radio"]:checked');
        if (selectedHTMLElement) { selectedHTMLElement.click(); }
});
// New -02-Dec : End

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.updateOptions();
    // this.removeSelectedVariant();
    this.disabledAddToCart();
    this.updateMasterId();
    this.updateSizevariantUpdate();
    this.clearSelectionClick = this.querySelector('.reset-opt');
    this.addEventListener('change', this.onVariantChange);
    this.addEventListener('click', this.onVariantClick);
    this.clearSelectionClick.addEventListener('click', this.clearSelectionAction.bind(this));
    this.clearSelectionClick.addEventListener('click', this.defaultSelectFirstVariant);
    // this.updateThumbnailsMedia();
  }
  
  defaultSelectFirstVariant(element){
    element.target.parentElement.querySelectorAll('fieldset').forEach((fildSet) => {
      if(fildSet.classList.contains("item-size")){
        fildSet.querySelector('label').click();
        // fildSet.parentElement.parentElement.querySelector('product-form form #product-form__buttons button span').innerHTML = "Select Color";
      }else{
        if(fildSet.classList.contains("item-color")){
          fildSet.classList.add("enable-selected");
          // fildSet.parentElement.parentElement.querySelector('product-form form #product-form__buttons button span').innerHTML = "“select a color first";
        }
      }
    });
    element.target.parentElement.querySelectorAll('fieldset label').forEach((fildSet) => {
      if(fildSet.classList.contains("hide")){
        fildSet.classList.remove("hide");
      }
    });
    element.target.classList.remove("show");
  }

  disabledAddToCart(){
    if(this.getVariantData().length >= 2){
      if(!this.querySelector("fieldset").classList.contains("item-amount")){
        // this.parentElement.querySelector('form button[type="submit"] span').innerHTML = "Select Color";
        // this.parentElement.querySelector('form button[type="submit"]').setAttribute("disabled", "");
      }
      this.parentElement.querySelector('form button[type="submit"]').classList.remove("hidden");
    }else{
      this.parentElement.querySelector('form button[type="submit"]').classList.remove("hidden");
    }
  }

  // removeSelectedVariant(){
  //   this.querySelector(".item-color [checked]").removeAttribute("checked");
  //   // console.log(this.querySelector(".item-color [checked]").removeAttribute("checked"));
  // }

  
  onVariantClick(element) {
    if( element.target.type && element.target.type == 'radio' ){
      if(element.target.name != "Denominations"){
        let allVariantsData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
        allVariantsData.forEach((allVariant) => {
          if(allVariant.option2 != "" && allVariant.option2 != null){
            this.clearSelectionClick.classList.add('show');
          }
        });
      }

      var selectedHTMLElement = event.target;
      var currentOption = selectedHTMLElement.parentElement.dataset.optionIndex;
      var CurrentSelectedValue = selectedHTMLElement.value;
      var allVariantsData = JSON.parse(this.querySelector('[type="application/json"]').textContent);

        if(element.target.name == "Color" || element.target.name == "COLOR" || element.target.name == "color" || element.target.name == "COLUOR" || element.target.name == "colour" || element.target.name == "Colour"){
            if(element.target.parentElement.classList.contains('enable-selected')){
              selectColorMessageDiv.style.display = 'none';
            }
        };

      if(currentOption == "option2"){
        selectedHTMLElement.parentElement.parentElement.querySelectorAll("fieldset.item-size input[type='radio']").forEach((firstOption)=>{
          if(selectedHTMLElement.parentElement.parentElement.querySelectorAll("fieldset.item-size input[type='radio']").length > 1){
            firstOption.nextElementSibling.classList.add("hide");
          }
        });

        if(element.target.name == "Color" || element.target.name == "COLOR" || element.target.name == "color" || element.target.name == "COLUOR" || element.target.name == "colour" || element.target.name == "Colour"){
          if(element.target.parentElement.classList.contains('enable-selected')){
            element.target.parentElement.classList.remove('enable-selected');
          }
        }

        // New -02-Dec : Start
        allVariantsData.forEach((variant) => {
          if(variant[currentOption] == CurrentSelectedValue){
            var option1New = "";
            if(variant.option1.includes("'")){
              option1New = variant.option1.replace("'", "\\'");
            }else{
              option1New = variant.option1;
            }
            selectedHTMLElement.parentElement.parentElement.querySelector("input[type='radio'][value='"+option1New+"']").nextElementSibling.classList.remove("hide");            
          }
        });

        // Get the fieldset by its data attribute
        const fieldset = document.querySelector('[data-option-index="option1"]');
        const selectedRadio = fieldset.querySelector('input[type="radio"]:checked');
        const selectedValue = selectedRadio ? selectedRadio.value : null;
        const filteredVariants = allVariantsData.filter((variant) => { return variant.option1 === selectedValue; });
        // New -02-Dec : End

        filteredVariants.forEach((variant) => {
          if(variant[currentOption] == CurrentSelectedValue){
            var option1New = "";
            if(variant.option1.includes("'")){
              option1New = variant.option1.replace("'", "\\'");
            }else{
              option1New = variant.option1;
            }
            selectedHTMLElement.parentElement.parentElement.querySelector("input[type='radio'][value='"+option1New+"']").nextElementSibling.classList.remove("hide");
            if(element.target.name != "Amount"){
              if(variant.available){
                if(selectedHTMLElement.parentElement.parentElement.parentElement.querySelector('product-form form button[type="submit"]').hasAttribute("disabled")){
                  selectedHTMLElement.parentElement.parentElement.parentElement.querySelector('product-form form button[type="submit"]').removeAttribute("disabled")
                  selectedHTMLElement.parentElement.parentElement.parentElement.querySelector('product-form form button[type="submit"] span').innerHTML = "Add to cart";
                  selectedHTMLElement.parentElement.parentElement.parentElement.querySelector('product-form form button[type="submit"]').classList.remove("hidden");
                }
              }else if(variant.available == false){
                if(!selectedHTMLElement.parentElement.parentElement.parentElement.querySelector('product-form form button[type="submit"]').hasAttribute("disabled")){
                  selectedHTMLElement.parentElement.parentElement.parentElement.querySelector('product-form form button[type="submit"]').setAttribute("disabled", "")
                  selectedHTMLElement.parentElement.parentElement.parentElement.querySelector('product-form form button[type="submit"] span').innerHTML = "Sold out";
                  selectedHTMLElement.parentElement.parentElement.parentElement.querySelector('product-form form button[type="submit"]').classList.remove("hidden");
                }
              }else{
                selectedHTMLElement.parentElement.parentElement.parentElement.querySelector('product-form form button[type="submit"]').setAttribute("disabled", "")
                selectedHTMLElement.parentElement.parentElement.parentElement.querySelector('product-form form button[type="submit"] span').innerHTML = "Unavailable";
                selectedHTMLElement.parentElement.parentElement.parentElement.querySelector('product-form form button[type="submit"]').classList.remove("hidden");
              }
            }
          }
        });
      }else if(currentOption == "option1"){
        selectedHTMLElement.parentElement.parentElement.querySelectorAll("fieldset.item-color input[type='radio']").forEach((firstOption)=>{
          allVariantsData.forEach((allVariant) => {
            if(allVariant.option2 != "" && allVariant.option2 != null){
              if(selectedHTMLElement.parentElement.parentElement.querySelectorAll("fieldset.item-color input[type='radio']").length > 1){
                firstOption.nextElementSibling.classList.add("hide");
              }
            }
          });
        });
        
        allVariantsData.forEach((variant) => {
          if(variant[currentOption] == CurrentSelectedValue){
            var option2New = "";
            if(variant.option2 != "" && variant.option2 != null){
              if(variant.option2.includes("'")){
                option2New = variant.option2.replace("'", "\\'");
              }else{
                option2New = variant.option2;
              }
              if(selectedHTMLElement.parentElement.parentElement.querySelector("input[type='radio'][value='"+option2New+"']")){
                selectedHTMLElement.parentElement.parentElement.querySelector("input[type='radio'][value='"+option2New+"']").nextElementSibling.classList.remove("hide");
              }
              if(variant.available == true){
                if(selectedHTMLElement.parentElement.parentElement.querySelector("input[type='radio'][value='"+option2New+"']").nextElementSibling.classList.contains("soldout")){
                  selectedHTMLElement.parentElement.parentElement.querySelector("input[type='radio'][value='"+option2New+"']").nextElementSibling.classList.remove("soldout");
                }
              }else{
                if(!selectedHTMLElement.parentElement.parentElement.querySelector("input[type='radio'][value='"+option2New+"']").nextElementSibling.classList.contains("soldout")){
                  selectedHTMLElement.parentElement.parentElement.querySelector("input[type='radio'][value='"+option2New+"']").nextElementSibling.classList.add("soldout");
                }
              }
            }
            if(element.target.name != "Amount"){
              if(this.querySelector(".js.product-form__input.item-color").classList.contains("enable-selected") && currentOption == "option1"){
                if(this.querySelector(".js.product-form__input.item-color").getAttribute("data-option-index") == currentOption){
                  if(variant.available == true){
                    this.parentElement.querySelector('product-form form div button[type="submit"]').removeAttribute("disabled");
                    this.parentElement.querySelector('product-form form div button[type="submit"] span').innerHTML = "Add to cart";
                    this.parentElement.querySelector('product-form form div button[type="submit"]').classList.remove("hidden");
                  }else{
                    this.parentElement.querySelector('product-form form div button[type="submit"]').setAttribute("disabled", "");
                    this.parentElement.querySelector('product-form form div button[type="submit"] span').innerHTML = "Sold out";
                    this.parentElement.querySelector('product-form form div button[type="submit"]').classList.remove("hidden");
                  }
                  // this.parentElement.querySelector('product-form form div button[type="submit"]').classList.add("hidden");
                  // setTimeout((() => {
                    // this.parentElement.querySelector('product-form form div button[type="submit"]').setAttribute("disabled", "");
                    // this.parentElement.querySelector('product-form form div button[type="submit"] span').innerHTML = "Select Color";
                    // this.parentElement.querySelector('product-form form div button[type="submit"]').classList.remove("hidden");
                  // }), 2000);
                }else{
                  // this.parentElement.querySelector('product-form form div button[type="submit"]').classList.add("hidden");
                  // setTimeout((() => {
                  //   this.parentElement.querySelector('product-form form div button[type="submit"]').setAttribute("disabled", "");
                  //   this.parentElement.querySelector('product-form form div button[type="submit"] span').innerHTML = "Select Color";
                  //   this.parentElement.querySelector('product-form form div button[type="submit"]').classList.remove("hidden");
                  // }), 2000);
                }
                // this.parentElement.querySelector('product-form form div button[type="submit"]').style.display = "none";
                // this.parentElement.querySelector('product-form form div button[type="submit"]').setAttribute("disabled", "");
                // this.parentElement.querySelector('product-form form div button[type="submit"] span').innerHTML = "Select Color";
                // this.parentElement.querySelector('product-form form div button[type="submit"]').classList.remove("hidden");
              }else{
                this.parentElement.querySelector('product-form form div button[type="submit"]').removeAttribute("disabled");
                this.parentElement.querySelector('product-form form div button[type="submit"] span').innerHTML = "Add to Cart";
                this.parentElement.querySelector('product-form form div button[type="submit"]').classList.remove("hidden");
              }
              if(element.target.name == "Color" || element.target.name == "COLOR" || element.target.name == "color" || element.target.name == "COLUOR" || element.target.name == "colour" || element.target.name == "Colour"){
                if(element.target.parentElement.classList.contains('enable-selected')){
                  element.target.parentElement.classList.remove('enable-selected');
                }
              }
            }
          }
        });
      }

      if(element.target.parentElement.querySelector("input[checked]")){
        element.target.parentElement.querySelector("input[checked]").removeAttribute("checked");
      }
      element.target.setAttribute("checked", "true");	
      if(element.target.name == "Color" || element.target.name == "Colour"){	
        document.querySelector(".selectedColor").innerHTML = element.target.value;	
      }	
      // new badge on variants	
      setTimeout((() => {
        let todayDate = new Date().toJSON().slice(0, 10);	
        if(document.querySelector(".selectedColor")){
            if(document.querySelector(".selectedColor").innerHTML != "" || document.querySelector(".selectedColor").innerHTML != null){
              this.getVariantData().forEach(((veriants) => {
                if(veriants.option1 == element.target.value){
                  if(variant_hide[veriants.id] != "" && variant_hide[veriants.id] != null && variant_hide[variants.id] >= todayDate){
                    if(!document.querySelector(".item-color label[data-name='"+veriants.option2+"']").classList.contains("newlabel")){
                      document.querySelector(".item-color label[data-name='"+veriants.option2+"']").classList.add("newlabel");
                    }
                  }
                }
              }));
              // if(this.currentVariant.option2 != ""){
              //   if(document.querySelector(".item-color label[data-name='"+this.currentVariant.option2+"']")){
              //     document.querySelector(".item-color label[data-name='"+this.currentVariant.option2+"']").classList.add("newlabel");
              //   }
              // }
            }
          }
      }), 3000);

      // element.target.parentElement.querySelector("input[checked]").removeAttribute("checked");
      // element.target.setAttribute("checked", "true");
      // if(element.target.name == "Color" || element.target.name == "Colour"){
      //   document.querySelector(".selectedColor").innerHTML = element.target.value;
      // }

      // new badge on variants
      // setTimeout((() => {
      //   let todayDate = new Date().toJSON().slice(0, 10);
      //   if(element.target.name != "Color"){
      //     if(document.querySelector(".selectedColor")){
      //       if(document.querySelector(".selectedColor").innerHTML != "" || document.querySelector(".selectedColor").innerHTML != null){
      //         this.getVariantData().forEach(((veriants) => {
      //           if(veriants.option1 = element.target.value){
      //             if(variant_hide[veriants.id] != "" && variant_hide[veriants.id] != null && variant_hide[variants.id] >= todayDate){
      //               if(!document.querySelector(".item-color label[data-name='"+veriants.option2+"']").classList.contains("newlabel")){
      //                 document.querySelector(".item-color label[data-name='"+veriants.option2+"']").classList.add("newlabel");
      //               }
      //             }
      //           }
      //         }));
      //       }
      //     }
      //   }
      // }), 3000);
      
      let optionNum = this.findOptionWithValue(element.target.value);
      if(element.target.name != "Denominations"){
        let allVariantsData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
        allVariantsData.forEach((allVariant) => {
          if(allVariant.option2 != "" && allVariant.option2 != null){
            this.clearSelectionClick.classList.add('show');
          }
        });
      }
      // if( optionNum ){
      //   const matchingVariants = this.getVariantData().filter(variant => variant[optionNum] === element.target.value);
      //   this.referenceOptionsData( matchingVariants, optionNum );
      // }
    }
  }

  clearSelectionAction(event){
    // this.parentElement.querySelector("product-form form #product-form__buttons button").style.display = "none";
    // setTimeout((() => {
      // this.querySelector("product-form")
      // this.parentElement.querySelector("product-form form #product-form__buttons button").setAttribute("disabled", "");
      // this.parentElement.querySelector("product-form form #product-form__buttons button span").innerHTML = "Select Color";
      // this.parentElement.querySelector("product-form form #product-form__buttons button").removeAttribute("style");
      // if(this.parentElement.querySelector("product-form form #product-form__buttons button").classList.contains("hidden")){
      //   this.parentElement.querySelector("product-form form #product-form__buttons button").removeAttribute("style");
      // }
    // }),2000);
    this.showAllOptions();
    this.clearSelectionClick.classList.remove('show');
    //this.classList.remove('show');
  }

  outOfStockUpdate(matchingVariants){
    if(document.querySelector('.item-color')){
      var colorindex = document.querySelector('.item-color').dataset.optionIndex;
      var itemcolor = document.querySelector('.item-color');
      matchingVariants.forEach(matchVariant => {
          if(!matchVariant.available){
            itemcolor.querySelector('input[value="'+matchVariant[colorindex]+'"]').nextElementSibling.classList.add("soldout");
          }else{
            itemcolor.querySelector('input[value="'+matchVariant[colorindex]+'"]').nextElementSibling.classList.remove("soldout");
          }
      });
    }
  }

  // referenceOptionsData(matchingVariants, optionNum){
  //   const optionData = ['option1','option2','option3'];
  //   this.hideoptions(optionData, optionNum);
  //   const variantValues = [];
  //   matchingVariants.forEach(matchVariant => {
  //     optionData.forEach(optionKey => {
  //       if( optionKey != optionNum ){
  //         if( matchVariant[optionKey] != null ){
  //           variantValues.push(matchVariant[optionKey]);
  //         }
  //       }
  //     });
  //   });
  //   this.outOfStockUpdate(matchingVariants);
  //   this.showoptions(variantValues, optionData, optionNum);
  // }

  // showoptions( variantValues, optionData, optionNum ){
  //   this.querySelectorAll('fieldset').forEach(function (element,key) {
  //     if( optionData[key] != optionNum ){
  //       element.querySelectorAll('input[type=radio]').forEach(function (radio) {
  //         if(variantValues.includes(radio.value)){
  //            radio.nextElementSibling.classList.remove('hide');
  //         }
  //       });
  //     }
  //   });
  // }

  showAllOptions(){
    this.querySelectorAll('fieldset').forEach(function (element,key) {
        element.querySelectorAll('input[type=radio]').forEach(function (radio) {
          radio.nextElementSibling.classList.remove('hide');
        });
    });
  }

  // hideoptions(optionData, optionNum){
  //   this.querySelectorAll('fieldset').forEach(function (element,key) {
  //     if( optionData[key] != optionNum ){
  //       element.querySelectorAll('input[type=radio]').forEach(function (radio) {
  //         if(radio.name != "Denominations"){
  //           radio.nextElementSibling.classList.add('hide');
  //         }
  //       });
  //     }
  //   });
  // }

  findOptionWithValue(value) {
    const variant = this.getVariantData().find(variant => Object.values(variant).includes(value));
    return variant ? Object.keys(variant).find(key => variant[key] === value) : null;
  }
  
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      // this.updateThumbnailsMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  // updateThumbnailsMedia(){
  //   if (!this.currentVariant) return;
  //   if (!this.currentVariant.featured_media) return;
  //   var sliderThumbnailsGalleries = document.getElementById(`Slider-Thumbnails-${this.dataset.section}`);
  //   var mediaThumbnailsGalleries = sliderThumbnailsGalleries.querySelectorAll('li');
    
  //   var currentVariantId = this.currentVariant.id;
  //   var currentVariantFeaturedImageId = this.currentVariant.featured_media.id;
  //   // Find the index of the current variant
  //   var currentIndex = this.getVariantData().findIndex(function(variant) {
  //     return variant.id == currentVariantId;
  //   });
  //   //console.log(currentIndex);
  //   // Find the next variant with the same featured_image ID
  //   var nextVariantIndex = currentIndex + 1;
  //   var nextVariant = null;
  //   while ( nextVariantIndex < this.getVariantData().length ) {
  //     if (this.getVariantData()[nextVariantIndex].featured_media.id == currentVariantFeaturedImageId) {
  //       nextVariantIndex++;
  //     } else {
  //       nextVariant = this.getVariantData()[nextVariantIndex];
  //       break;
  //     }
  //   }
  //   var nextVariantFeaturedImageId = nextVariant ? nextVariant.featured_media.id : null;
  //   // console.log("Next variant's different featured_image id:", nextVariantFeaturedImageId);
  //   // Extract image IDs between the two featured image IDs
  //   var imageIdsInRange = [];
  //   var withinRange = false;
  //   var mediaIdsInList = JSON.parse(document.getElementById(`ProductMedia-${this.dataset.section}`).textContent);
  //   mediaIdsInList.forEach(function(mediaItem) {
  //     if (mediaItem.id == currentVariantFeaturedImageId) {
  //       withinRange = true;
  //     }
  //     if (mediaItem.id == nextVariantFeaturedImageId) {
  //       withinRange = false;
  //     }
  //     if (withinRange) {
  //       imageIdsInRange.push(mediaItem.id.toString());
  //     }
  //   });
  //   // console.log("Image IDs between current and next variant:", imageIdsInRange);
  //   mediaThumbnailsGalleries.forEach(function(mediaThumbnailsGallery) {
  //     mediaThumbnailsGallery.classList.add('hide');
  //     var mediaId = mediaThumbnailsGallery.getAttribute('data-media-id');
  //     if (imageIdsInRange.indexOf(mediaId.toString()) !== -1) {
  //       mediaThumbnailsGallery.classList.remove('hide');
  //     }
  //   });
  // }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  updateSizevariantUpdate(){
    if (!this.currentVariant) return;


    if(document.querySelector('.item-color')){
      var colorindex = document.querySelector('.item-color').dataset.optionIndex;
      var itemcolor = document.querySelector('.item-color');
    }

    if(document.querySelector('.item-size')){
      var sizeindex = document.querySelector('.item-size').dataset.optionIndex;
      var listSize = document.querySelector('.item-size');
    }

    if(document.querySelector('.item-size') && document.querySelector('.item-color')){
      var selectedSize = this.currentVariant[sizeindex];
      this.getVariantData().find((variant) => {
        if( variant[sizeindex] == selectedSize ){
          if(!variant.available){
            itemcolor.querySelector('input[value="'+variant[colorindex]+'"]').nextElementSibling.classList.add("soldout");
          }else{
            itemcolor.querySelector('input[value="'+variant[colorindex]+'"]').nextElementSibling.classList.remove("soldout");
          }
        }
      });
    }
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);

        publish(PUB_SUB_EVENTS.variantChange, {data: {
          sectionId,
          html,
          variant: this.currentVariant
        }});
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);


// START: code for display message "Select a color first"
  let selectColorMessageDiv;
  document.addEventListener("DOMContentLoaded", function() {
    const form = document.querySelector('.product-form__buttons').closest('form'); 
    const submitButton = document.querySelector('.product-form__submit');
    
    // Function to add the message above the "Add to cart" button
    function addMessage() {
      selectColorMessageDiv = document.createElement('div');
      selectColorMessageDiv.id = 'color-message';
      selectColorMessageDiv.className = 'color-message';
      selectColorMessageDiv.textContent = 'Select a color first';
      selectColorMessageDiv.style.display = 'none'; 
      form.insertBefore(selectColorMessageDiv, submitButton.parentElement);
    }
    addMessage();
  });
// END: code for display message "Select a color first"
